/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnitCostLogDtoPage } from '../../models/unit-cost-log-dto-page';

export interface ListUnitCostLogs$Params {
  workPackageId?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'units' | '-units' | 'comment' | '-comment' | 'fixedDate' | '-fixedDate' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'workPackage' | '-workPackage' | 'unitCost' | '-unitCost' | 'loggedBy' | '-loggedBy'>;
}

export function listUnitCostLogs(http: HttpClient, rootUrl: string, params?: ListUnitCostLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostLogDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listUnitCostLogs.PATH, 'get');
  if (params) {
    rb.query('workPackageId', params.workPackageId, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnitCostLogDtoPage>;
    })
  );
}

listUnitCostLogs.PATH = '/v0/unitCostLogs';
